/* @flow */
import { resignAdminship } from 'admin/actions/OrgRoleActions';
import ConfirmDialog from 'components/ConfirmDialog';
import CurrentUser from 'auth/CurrentUser';
import * as React from 'react';
import ToastActions from 'actions/ToastActions';

import type { organizationDefault } from 'organizations/fragments/__generated__/organizationDefault';

type Props = {
  school: organizationDefault,
  onRequestHide?: Function,
};

class AdminResignModal extends React.Component<Props> {
  resignAsAdmin = () => {
    return resignAdminship(this.props.school.id, CurrentUser.getUserId()).then(
      () =>
        ToastActions.showSuccessToast(
          `You have been removed as administrator of ${this.props.school.name}`
        ),
      ToastActions.showDefaultErrorToast
    );
  };

  render() {
    return (
      <ConfirmDialog
        eventScreenName="AdminResignModal"
        title={`Remove yourself as administrator of ${this.props.school.name}?`}
        subtext="Once you do, you won’t have access to your school’s staff list,
          staff messaging, and other features for verified administrators."
        actionButtonText="Remove myself as administrator"
        cancelButtonText="Cancel"
        className="AdminResignModal"
        preConfirmPromise={this.resignAsAdmin}
        actionButtonColor="lava"
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}
export default AdminResignModal;
